import { TestService } from './Test';
import { GoalsService } from './Goals';
import { LeaveAllocationService } from './LeaveAllocation';
import { PublicHolidayService } from './PublicHolidayService';
import { AttendanceTrackingService } from './AttendanceTrackingService';
import { HrManagerService } from './HrManagerService';
import { VehicleService } from './VehicleService';

export const agent = {
  TestService,
  GoalsService,
  LeaveAllocationService,
  PublicHolidayService,
  AttendanceTrackingService,
  HrManagerService,
  VehicleService
};
